/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type InternalListAIConfigReferencesPathParams = NonNullable<
  operations['internalListAIConfigReferences']['parameters']['path']
>;

export type InternalListAIConfigReferencesQueryParams = NonNullable<
  operations['internalListAIConfigReferences']['parameters']['query']
>;

export interface Input extends InternalListAIConfigReferencesPathParams {
  apiVersion?: string;
  query?: InternalListAIConfigReferencesQueryParams;
}

export async function internalListAIConfigReferences(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/internal/projects/{projectKey}/ai-configs/{configKey}/references', {
    params: { path, query },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
